import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, X } from 'lucide-react';

const ContactButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end">
      {/* Popup Window */}
      {isOpen && (
        <div className="mb-4 w-80 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden transform transition-all">
          <div className="bg-primary/5 p-4 border-b border-primary/10 flex justify-between items-center">
            <div>
              <h3 className="font-semibold text-gray-900">{t('contactfiba', 'Холбоо барих')}</h3>
              <p className="text-xs text-gray-500 mt-1">{t('workhour', 'Ажлын цаг')}: 09:00 - 18:00</p>
            </div>
            <button 
              onClick={() => setIsOpen(false)}
              className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          
          <div className="p-2">
            <a 
              href="tel:75092211" 
              className="flex items-center gap-4 p-3 hover:bg-gray-50 rounded-xl transition-colors group"
            >
              <div className="w-10 h-10 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                <Phone className="w-5 h-5" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">7509-2211</p>
                <p className="text-xs text-gray-500">{t('phone', 'Утас')}</p>
              </div>
            </a>

            <a 
              href="mailto:hello@negdi.mn" 
              className="flex items-center gap-4 p-3 hover:bg-gray-50 rounded-xl transition-colors group"
            >
              <div className="w-10 h-10 rounded-full bg-green-50 text-green-600 flex items-center justify-center group-hover:bg-green-100 transition-colors">
                <Mail className="w-5 h-5" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">hello@negdi.mn</p>
                <p className="text-xs text-gray-500">{t('email', 'И-мэйл')}</p>
              </div>
            </a>

          
          </div>
        </div>
      )}

      {/* Floating Action Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="group relative w-14 h-14 bg-primary text-primary-foreground rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200 active:scale-95"
      >
        {isOpen ? (
          <X className="w-6 h-6" />
        ) : (
          <Phone className="w-6 h-6" />
        )}
      </button>
    </div>
  );
};

export default ContactButton;